export default {
    methods: {
        getDatapointType(data, oid = false) {
            // check for enum translation existence to fix 2/9
            if (oid && this.$te(`enums.${oid}`)) {
                return 'enum';
            }

            if (this.oid == '51/107' || this.oid == '51/108' || this.oid == '51/109') {
                return 'program-fromto';
            }

            switch (data.unitId) {
                case 20:
                    return 'date';
                case 21:
                    return 'time';
                default:
                    break;
            }

            switch (data.typeId) {
                case 9:
                    return 'enum';
                case 30:
                    switch (data.subtypeId) {
                        case 8:
                            return 'number';
                        case 9:
                            return 'text';
                        case 10:
                        case 11:
                            return 'object';
                        case 7:
                        case 14:
                        case 15:
                            if (this.oid == '5/65') {
                                return 'program-switch';
                            } else if (this.oid == '50/14') {
                                return 'program-toggle';
                            } else if (this.oid == '54/7') {
                                return 'program-tarif';
                            } else if (this.oid == '51/107' || this.oid == '51/108' || this.oid == '51/109') {
                                return 'program-fromto';
                            } else {
                                return 'program';
                            }
                        default:
                            return 'text';
                    }
                default:
                    return 'number';
            }
        },
        getDatapointUnit(data) {
            switch (data.unitId) {
                case 10:
                    return this.$t('units.10');
                case 42:
                    return 'm³';
                case 48:
                    return 'A';
                case 49:
                    return 'm³/h';
                case 50:
                    return 'Hz';
                case 51:
                    return 'g';
                case 52:
                    return '¤/kWh';
                case 53:
                    return '¤/t';
                default:
                    return data.unit;
            }
        },
        getDatapointBitmaskValue(data) {
            let bit = (parseInt(data.value) && data.mask) >> data.bit;
            return bit == 1 ? 'on' : 'off';
        },
        getDatapointLabel(type, value, oid = false, bitmaskValue = false, unit = '') {
            if (type === 'enum') {
                return this.$t(`enums.${oid}.${value}`);
            } else if (type === 'program-fromto') {
                return `${value.length}&nbsp;${this.$t('systems.parameters.time_programs')}`;
            } else if (type === 'bitmask') {
                return this.$t(`systems.parameters.${bitmaskValue}`);
            } else if (type === 'program' || type === 'program-switch' || type === 'program-tarif' || type === 'program-toggle') {
                return `${value.length}&nbsp;${this.$t('systems.parameters.time_programs')}`;
            } else if (type === 'number') {
                return `${value}${unit}`;
            } else if (type === 'object') {
                return JSON.stringify(value);
            } else if (['date', 'time'].indexOf(type) >= 0) {
                return value;
            } else {
                return `${value}${unit}`;
            }
        },
    },
};
